import React from 'react';
import Card from '../components/Card';
import ProjectCard from '../components/ProjectCard';
import projectsImg from '../utils/images/projects.jpg';

const Projects = () => {
    const projects = [
        {
            title: 'SPENNY',
            link: 'https://spenny.com/',
            description:
                'Website for the startup ”Spenny” that explains their product (mobile app) to the users.',
        },
        {
            title: 'COMPRE SCHEDULER',
            link: '',
            description:
                'Study Oriented Project under Prof. Sujith Thomas.\nDigitizing the process of allocating rooms, invigilators, and students during the comprehensive exams.',
        },
        {
            title: 'ERP ASSIST',
            link: 'https://github.com/satejbidvai/ErpExtend',
            description:
                'Chrome Extension to simplify the semester registration process for students of BITS Pilani, Goa',
        },
    ];

    return (
        <Card icon="🛠️" title="MY PROJECTS!" image={projectsImg}>
            <ul className="list-disc list-outside text-left text-lg tracking-widest pl-5 space-y-5 lg:space-y-8">
                {projects.map((project) => (
                    <ProjectCard
                        key={project.title}
                        title={project.title}
                        link={project.link}
                        description={project.description}
                    />
                ))}
            </ul>
        </Card>
    );
};

export default Projects;
